// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

// import * as Sentry from '@sentry/nextjs';

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"1792656704924"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import { init, replayIntegration } from '@sentry/nextjs';

init({
	dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
	debug: false,
	replaysOnErrorSampleRate: 1.0,
	tracesSampleRate: 0,
	replaysSessionSampleRate: 0,
	integrations: [
		replayIntegration({
			maskAllText: false,
			maskAllInputs: false,
			blockAllMedia: false,
		}),
	],

	ignoreErrors: [
		'ResizeObserver loop limit exceeded',
		'ResizeObserver loop completed with undelivered notifications.',
		"Can't find variable: _AutofillCallbackHandle",
		'getRestrictions is not a function',
		"Can't find variable: fbq",
		'fbq is not defined',
		'Non-Error promise rejection captured with value: Object Not Found',
		'Non-Error exception captured',
		'Non-Error promise rejection captured',
		'Error: ib',
		'Error: jb',
		'Error: Sd',
		'Error: Xd',
		'Error: Yd',
		"Cannot read properties of null (reading 'readyState')",
	],
	environment: process.env.NEXT_PUBLIC_SENTRY_ENV,
});
